module.exports = __webpack_public_path__ + "static/media/img-0b53296b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/myze-logo.png
// module id = 5295
// module chunks = 39